<div class="flex items-center justify-center h-full">
  <div class="flex flex-col mt-20 items-center justify-center text-center">
      <div class="flex items-center justify-center">
        <activar-icon [name]="getIcon()" size="80px" class="mb-5" />
      </div>
      
      <h2>{{title}}</h2>
      <p>{{message}}</p>
  </div>
</div>